// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MITs
export const enum AuthClientTypes {
  General = 'General Auth Client',
  Social = 'Social Auth Client',
}
